<template>
  <div class="user-menu">
    <!-- <h2>个人中心</h2> -->
    <div class="menu-list">
      <div v-for="(item, index) in menus" :key="index">
        <div
          @click="tab(item,index)"
          class="menu-item"
          :class="{ active: item.title === title }"
        >
          <img
            :src="item.title === title ? item.iconCurImg : item.iconImg"
            class="icon-img"
          />
          <span class="title"> {{ item.title }} </span>
        </div>
        <div v-if="item.children && item.children.length > 0" class="sub-menu">
          <ul>
            <li v-for="(child, ic) in item.children" :key="ic" @click="onChildClick(item,child)" :class="[child.title === sub_title ? 'active' : '']">
              {{ child.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkBenchMenu",
  props: {},
  data() {
    return {
      title: "",
      sub_title: "",
      menus: [
        {
          name: "WorkBenchHome",
          title: "My Dashboard",
          path: "/workbench/home",
          iconImg: require("../../assets/images/user/icon-workbench.png"),
          iconCurImg: require("../../assets/images/user/icon-workbench-active.png"),
        },
        {
          name: "MyCreation",
          title: "My Content",
          iconImg: require("../../assets/images/user/icon-creations.png"),
          iconCurImg: require("../../assets/images/user/icon-creations-active.png"),
          children: [
            {
              name: "MyCreations",
              title: "My Posts",
              path: "/workbench/creations",
            },
            {
              name: "WorkBenchMyTemplate",
              title: "My Designs",
              path: "/workbench/template",
            },
          ],
        },
        {
          name: "Social",
          title: "My Network",
          iconImg: require("../../assets/images/user/icon-myfollow.png"),
          iconCurImg: require("../../assets/images/user/icon-myfollow-active.png"),
          children: [
            {
              name: "MyFollow",
              title: "Following",
              path: "/workbench/fansfollow/follow",
            },
            {
              name: "MyFans",
              title: "Followers",
              path: "/workbench/fansfollow/fans",
            },
          ],
        },

        {
          name: "AccountManage",
          title: "My Account",
          iconImg: require("../../assets/images/user/icon-center.png"),
          iconCurImg: require("../../assets/images/user/icon-center-active.png"),
          children: [
            {
              name: "UserCenter",
              title: "Profile",
              path: "/workbench/center",
            },
            {
              name: "OrderCenter",
              title: "Order Center",
              path: "/order/center",
            },

            {
              name: "ShopHome",
              title: "My Store",
              path: "/shop/home?uid=" + this.$store.state.userInfo?.code,
            },
          ],
        },
      ],
      height: "500px",
    };
  },
  watch: {
    $route(to) {
      let name = to.name;
      this.menus.forEach((item) => {
        if (item.name === name) {
          this.title = item.title;
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.name === "FansFollow") {
        switch (to.params.type) {
          case "follow":
            this.title = "我的关注";
            break;
          case "fans":
            this.title = "粉丝管理";
            break;
        }
      }
    });
  },
  created() {
    this.height = window.innerHeight - 78 + "px";
    let name = this.$route.name;
    if (name === "FansFollow") {
      switch (this.$route.params.type) {
        case "follow":
          this.title = "我的关注";
          break;
        case "fans":
          this.title = "粉丝管理";
          break;
      }
    }
    this.menus.forEach((item) => {
      if (item.name === name) {
        this.title = item.title;
      }
    });
    console.log("route", this.$route);
    // console.log('this.title',this.title);
  },
  methods: {
    onChildClick(parent, child) {
      this.sub_title = !child ? "" : child.title;
      this.title = parent.title;
      console.log("child", child);
      this.$router.push({
        path: child.path,
        params: { sub_title: child.title },
      });
    },
    tab(e, index) {
      // if(['MyFollow','MyFans'].includes(e.name)){
      // 	this.$layer.msg('暂未开放');
      // 	return;
      // }
      switch (e.name) {
        case "MyFollow":
          this.$router.push({
            name: "MyFollow",
            params: {
              type: "follow",
            },
          });
          break;
        case "MyFans":
          this.$router.push({
            name: "MyFans",
            params: {
              type: "fans",
            },
          });
          break;
        default:
          if (!e.path) {
            this.onChildClick(e, this.menus[index].children[0]);
            return;
          }
          if (e.name === "WorkBenchHome") {
            this.sub_title = "";
          }
          this.$router.push({
            path: e.path,
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-menu {
  width: 350px;
  background: #ffffff;
  padding-top: 40px;
  height: 100%;

  h2 {
    padding: 30px 0 24px 28px;
    color: #333;
    font-weight: bold;
  }

  .menu-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 100px;
    .menu-item {
      width: 200px;
      height: 40px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      cursor: pointer;
      .icon-img {
        width: 21px;
        height: 21px;
        margin-left: 11px;
        margin-right: 9px;
      }

      &.active {
        background: #0D0C22;
        font-size: 16px;
        color: #ffffff;
        border-radius: 5px;
      }
    }
    .sub-menu {
      color: #333333;
      font-size: 15px;
      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          position: relative;
          /* 用于定位伪元素 */
          padding-left: 25px;
          margin-left: 25px;
          /* 为正方形留出空间 */
          // border-bottom: 1px solid #ddd;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          transition: background 0.3s;
          color: #000000;
          height: 40px;
          font-size: 16px;
          line-height: 40px;

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            /* 垂直居中 */
            width: 7px;
            height: 7px;
            background-color: #b3b3b3;
            /* 黑色正方形 */
            border-radius: 2px;
            /* 可选：轻微圆角 */
            margin-left: 10px;
            margin-right: 15px;
          }

          &:hover,
          &.active {
            color: #FA3D5A;
            font-weight: bold;
            &::before {
              background-color: #FA3D5A;
            }
          }
        }
      }
    }
  }
}
</style>
